import { dispatchAction } from '@ardoq/rxbeach';
import {
  addBookmark,
  setBookmarkName as setBookmarkNameAction,
  setBookmarkFolder as setBookmarkFolderAction,
} from './actions';
import { tracking } from './tracking';
import { SelectedFolder } from '../components/FolderSelectDialog/types';

const saveBookmark = (bookmarkName: string, folderId: string | null) => {
  dispatchAction(
    addBookmark({
      bookmarkName,
      folderId,
    })
  );
  tracking.trackClickedSaveAsBookmark(folderId !== null);
};

const setBookmarkName = (bookmarkName: string) =>
  dispatchAction(setBookmarkNameAction(bookmarkName));

const setBookmarkFolder = (folder: SelectedFolder) =>
  dispatchAction(setBookmarkFolderAction(folder));

type BookmarkCommands = {
  saveBookmark: (bookmarkName: string, folderId: string | null) => void;
  setBookmarkName: (bookmarkName: string) => void;
  setBookmarkFolder: (folder: SelectedFolder) => void;
};

const bookmarkCommands: BookmarkCommands = {
  saveBookmark,
  setBookmarkName,
  setBookmarkFolder,
};

export { bookmarkCommands };
